<template>
    <div>

        <!-- Banner -->
        <banner-generic :data="data.hero"></banner-generic>

        <section class="downloads-filter space--sm">
            <div class="container">
                <div class="row">
                        <div class="col-xs-12">
                            <div class="filter-wrapper filter-wrapper--text-only">
                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--primary" @scroll="slideOnScroll('filter-wrapper--primary')">
                                        <div class="items">
                                            <a href="#" 
                                                class="category" 
                                                :class="[
                                                    selectedFilter.category.includes(category.urlsegment) ? 'selected' : null
                                                ]" 
                                                v-for="(category, index) in filterKeys.categories" 
                                                :key="index" 
                                                @click.prevent="filter(category.filterid, 'category', category.urlsegment)" 
                                                :data-id="category.filterid"
                                            >{{category.title}}</a>
                                            
                                            <div class="spacer">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <button id="filter-wrapper--prev--primary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--primary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--primary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--primary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="filter-wrapper filter-wrapper--text-icon">
                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--secondary" @scroll="slideOnScroll('filter-wrapper--secondary')">
                                        <div class="items">

                                            <a href="#" @click.prevent="filter('reset-this-filter', 'tag', null)"
                                                :class="[
                                                    selectedFilter.tag.length<=0 ? 'selected' : null
                                                ]" 
                                            >All</a>
                                            <a href="#" 
                                                class="tag"
                                                :class="[
                                                    selectedFilter.tag.includes(tag.urlsegment) ? 'selected' : null
                                                ]" 
                                                v-for="(tag, index) in filterKeys.tags" 
                                                :key="index" 
                                                @click.prevent="filter(tag.filterid, 'tag', tag.urlsegment)" 
                                                :data-id="tag.filterid"
                                            >{{tag.title}}</a>

                                            <div class="spacer">&nbsp;</div>

                                        </div>
                                    </div>
                                </div>
                                
                                <button id="filter-wrapper--prev--secondary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--secondary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>

                            <div class="filter-wrapper--separator"></div>
                        
                        </div>
                </div>
            </div>
        </section>

        <!-- PDF block -->
        <div>
            <div class="padding--sm-top padding--xl-bottom">
                <div class="container">
                    <div class="row">

                        <div 
                            class="download-item col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" 
                            :class="(index<itemsToShow) ? '' : 'hidden'"
                            v-for="(item, index) in filteredItems" 
                            :key="index" 
                        >
                            
                            <div class="row padding--lg-top padding--sm-bottom">
                                <div class="part-image col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                    <image-item
                                        class="image"
                                        :source="imageUrlCheck(item.image)"
                                        :alt="item.title"
                                        position="right"
                                        :outofStock="item.outofStock"
                                        :outofStockMessage="item.outofStockMessage"
                                    ></image-item>
                                </div>
                                <div class="part-desc col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                    <div class="content">
                                        <h4 class="medium resource-title">{{item.title}}</h4>
                                        <p>{{item.summary}}</p>
                                        <div class="actions">
                                            <a v-if="item.downloadLink" :href="item.downloadLink" aria-label="Download" title="Download" class="button button--solid-black" target="_blank" download data-category="Brochure" data-action="Download" :data-label="item.title">Download</a>
                                            <a v-if="item.requestLink" :href="item.requestLink" aria-label="Request a copy" title="Request a copy" class="button button--clear-black" data-category="Request" data-action="Submit" data-label="Brochure">Request a copy</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border"></div>

                        </div>

                    </div>
                </div>

            </div>
            <div class="space-bottom--xl">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="text-center">
                                <div v-if="itemsToShow < filteredItems.length || filteredItems.length > itemsToShow">
                                    <button class="button button--solid-black" @click="itemsToShow += 6">Show More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- elements -->
        <div v-for="element in data.elements" :key="element.id">
            <component :is="element.vueName" :data="element" />
        </div>

    </div>
</template>

<script>
import ImageItem from "../components/Image/ImageItem";
import { BannerGeneric } from "../components";
import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours, ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";

export default {
    name: "v-downloads",
    components: {
        ImageItem,
        BannerGeneric,
        ElementBackgroundImage,
        ElementAccordion,
        ElementColours,
        ElementContent,
        ElementCTA,
        ElementLinks,
        ElementImages,
        ElementImage,
        ElementProducts,
        ElementSplitSlider,
        ElementTiles,
        ElementVideo,
        ElementPercentage,
        ElementForm
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {
            itemsToShow: 12,
            totalItems: 0,
            items: [],
            filteredItems: [],
            selectedFilter: {
                category: [],
                tag: []
            },
            filterKeys: {
                categories: [],
                tags: []
            },
            intervalID: 0
        }
    },
    methods: {
        imageUrlCheck(url){
            if(typeof url !== 'string'){
                // if image variable is invalid for some reason
                return 'https://via.placeholder.com/1200x1700.png';
            }

            return url;
        },
        filter(key, type, value){
            // single select filter
            if (this.selectedFilter[type].includes(value)) {
                this.selectedFilter[type] = [];
            } else {
                let selectedFilter = [];
                selectedFilter.push(value);
                this.selectedFilter[type] = selectedFilter;
            }

            if(key==='reset-this-filter'){
                this.selectedFilter[type] = [];
            }

            let filteredList = this.filterbyTagsAndCategories(this.items, this.selectedFilter);
            this.filteredItems = filteredList;

            this.itemsToShow = 12;
            this.totalItems = this.filteredItems.length;
        },
        slidePrev(id) {
            const elem = document.getElementById(id);
            elem.scrollBy(window.innerWidth/3 * (-1), 0);
        },
        slideNext(id) {
            const elem = document.getElementById(id);
            elem.scrollBy(window.innerWidth/3, 0);
        },
        slideOnScroll(id) {
            const slideBuffer = 10;
            const elem = typeof id === 'string' ? document.getElementById(id) : id;
            const isScrolling = elem.querySelector('.items').offsetWidth > elem.offsetWidth;

            elem.parentNode.parentNode.classList.add('no-scroll');
            if(isScrolling){
                elem.parentNode.parentNode.classList.remove('no-scroll');
            }

            if(isScrolling && elem.scrollLeft >= (elem.querySelector('.items').offsetWidth - elem.offsetWidth - slideBuffer)) {
                elem.parentNode.parentNode.classList.add('is-max');
                elem.parentNode.parentNode.classList.remove('is-min');
            } else if(isScrolling && elem.scrollLeft <= slideBuffer) {
                elem.parentNode.parentNode.classList.remove('is-max');
                elem.parentNode.parentNode.classList.add('is-min');
            } else {
                elem.parentNode.parentNode.classList.remove('is-max');
                elem.parentNode.parentNode.classList.remove('is-min');
            }
        },
        detectButtonVisibility() {
            let status = true;

            const slideItems = [
                document.getElementById('filter-wrapper--primary'),
                document.getElementById('filter-wrapper--secondary')
            ];
            const slideButtons = [
                document.getElementById('filter-wrapper--next--primary'),
                document.getElementById('filter-wrapper--next--secondary')
            ];

            slideItems.forEach((elem, index) => {
                if(elem){
                    if(elem.querySelector('.items').offsetWidth<=0) status = false;
                    if(elem.querySelector('.items').offsetWidth<=elem.offsetWidth){
                        slideButtons[index].classList.add('hidden');
                    }else{
                        slideButtons[index].classList.remove('hidden');
                    }

                    this.slideOnScroll(elem);
                }
            });

            return status;
        }
    },
    mounted() {
        this.items = this.convertItemsObjToArray( this.data.resources )
        this.filteredItems = this.filterbyTagsAndCategories( this.items, this.selectedFilter )
        this.totalItems = this.items.length

        this.filterKeys = this.getFilteredCatAndTagList(this.items, this.data.categories, this.data.tags);

        const app = this;

        this.intervalID = setInterval(() => {
            let status = app.detectButtonVisibility();
            if(status) clearInterval(this.intervalID );
        }, 100);

        window.addEventListener('resize', () => {
            clearTimeout(this.intervalID);
            this.intervalID = setTimeout(() => {
                app.detectButtonVisibility();
            }, 250);
        });
    }
};
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";
    .download-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &.hidden {
            display: none;
        }

        > .border {
            border-bottom: solid 1px rgba(#2D2C2C,0.5);
        }

        .container {
            border-bottom: 1px solid;
            padding-bottom: 3rem;
            padding-top: 3rem;
        }

        .resource-title {
            font-size: 16px;
            font-size: 1rem;
            margin-top: 0;
            margin-bottom: 2rem;
        }

        .part-image {
            @media (max-width:767px) {
                margin-bottom: 1rem;
            }
        }
    }
</style>
